<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Empresas Cadastradas'">
          <template v-slot:preview>
            <div col-md-2 col-lg-2>
              <v-btn
                v-if="verificarPermissao(permissoesPadrao.Incluir)"
                color="primary"
                fab
                x-small
                dark
                @click="novaEmpresa"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </div>
            <br />
            <v-row>
              <v-col cols="6" offset="6">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Pesquisa"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="empresas"
              :search="search"
              :items-per-page.sync="itemsPerPage"
              :page.sync="page"
            >
              <template v-slot:item="{ item, index }">
                <tr>
                  <td>{{ item.id }}</td>
                  <td>{{ item.nome }}</td>
                  <td>{{ item.cpfcnpj }}</td>
                  <td>
                    {{
                      item.dataVigenciaFim
                        ? formatDate(item.dataVigenciaFim)
                        : "-"
                    }}
                  </td>
                  <td style="min-width: 150px" align="center">
                    <download-excel
                      :ref="'download-relatorio-' + index"
                      class="d-none"
                      :data="configExportar.relatorioExportar"
                      :name="configExportar.nomeArquivo"
                    >
                    </download-excel>
                    <download-excel
                      :ref="'download-relatorio-pendencias-' + index"
                      class="d-none"
                      :data="configExportarPendencias.pendenciasExportar"
                      :name="configExportarPendencias.nomeArquivo"
                    >
                    </download-excel>
                    <v-btn
                      v-if="
                        verificarPermissao(permissoesPadrao.Editar) &&
                        item.dataVigenciaFim == null
                      "
                      color="warning"
                      fab
                      x-small
                      dark
                      @click="editar(item.id)"
                      ><v-icon>mdi-pencil</v-icon></v-btn
                    >
                    <v-btn
                      v-if="
                        verificarPermissao(permissoesPadrao.Excluir) &&
                        item.dataVigenciaFim == null
                      "
                      color="error"
                      fab
                      x-small
                      dark
                      @click="inativar(item.id, index)"
                      class="ml-2"
                      ><v-icon>mdi-trash-can</v-icon></v-btn
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          fab
                          x-small
                          dark
                          @click.stop="downloadRelatorio(item.id, index)"
                          class="ml-2"
                          ><v-icon>mdi-file-export</v-icon></v-btn
                        >
                      </template>
                      <span>Relatório de entidades</span>
                    </v-tooltip>
                    <v-menu offset-y close-on-content-click>
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                              v-bind="attrs"
                              v-on="{ ...menu, ...tooltip }"
                              color="primary"
                              fab
                              x-small
                              dark
                              class="ml-2"
                              ><v-icon>mdi-file-excel</v-icon></v-btn
                            >
                          </template>
                          <span>Relatório de pendências</span>
                        </v-tooltip>
                      </template>
                      <v-list>
                        <v-list-item
                          @click="downloadRelatorioPendencias(item.id, index)"
                        >
                          <v-list-item-title>Todas Pedencias</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="
                            downloadRelatorioPendenciasStatus(item.id, index, 1)
                          "
                        >
                          <v-list-item-title>Aprovado</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="
                            downloadRelatorioPendenciasStatus(item.id, index, 0)
                          "
                        >
                          <v-list-item-title>Reprovado</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="
                            downloadRelatorioPendenciasStatus(item.id, index, 2)
                          "
                        >
                          <v-list-item-title
                            >Aguardando Arquivos</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item
                          @click="
                            downloadRelatorioPendenciasStatus(item.id, index, 3)
                          "
                        >
                          <v-list-item-title
                            >Aguardando Aprovação</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import { SET_LOADING } from "@/store/config.module";
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import RelatorioService from "@/common/services/http/relatorio.service";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";

export default {
  name: "empresa",
  data() {
    return {
      page: 1,
      permissoesPadrao: {},
      itemsPerPage: 1,
      empresas: [],
      search: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "Nome", value: "nome" },
        { text: "CPFCNPJ", value: "cpfcnpj" },
        { text: "Data Vigência Fim", value: "dataVigenciaFim" },
        { text: "", value: "" },
      ],
      configExportar: {
        relatorioExportar: [],
        nomeArquivo: "",
      },
      configExportarPendencias: {
        pendenciasExportar: [],
        nomeArquivo: "",
      },
      cliente: {},
    };
  },
  components: {
    KTCodePreview,
  },
  methods: {
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },
    async downloadRelatorio(empresaID, index) {
      let config = await RelatorioService.relatorioEntidades(
        { empresaID },
        "Empresa"
      );

      if (config) {
        this.configExportar = config;
        setTimeout(() => {
          this.$refs["download-relatorio-" + index].$el.click();
        }, 1000);
      }
    },
    async downloadRelatorioPendencias(empresaID, index) {
      let config = await RelatorioService.relatorioPendencias({ empresaID });

      if (config) {
        this.configExportarPendencias = config;
        setTimeout(() => {
          this.$refs["download-relatorio-pendencias-" + index].$el.click();
        }, 1000);
      }
    },
    async downloadRelatorioPendenciasStatus(empresaID, index, statusPendencia) {
      let config = await RelatorioService.relatorioPendenciasStatus({
        empresaID,
        status: statusPendencia,
      });
      if (config) {
        this.configExportarPendencias = config;
        setTimeout(() => {
          this.$refs["download-relatorio-pendencias-" + index].$el.click();
        }, 1000);
      }
    },
    novaEmpresa() {
      this.popularPaginacaoEmpresas();
      this.$router.push({ name: "empresaCadastro" });
    },

    popularPaginacaoEmpresas() {
      const tabelaEmpresas = {
        page: this.page,
        itemsPerPage: this.itemsPerPage,
      };

      sessionStorage.setItem("tabelaEmpresas", JSON.stringify(tabelaEmpresas));
    },

    listaEmpresas() {
      return new Promise((resolve) => {
        ApiService.get("empresa/getbyclienteid/" + this.cliente.id).then(
          ({ data }) => {
            resolve(data);

            if (data.success) {
              this.page = 1;
              this.itemsPerPage = 10;

              const tabelaEmpresas = sessionStorage.getItem("tabelaEmpresas")
                ? JSON.parse(sessionStorage.getItem("tabelaEmpresas"))
                : null;

              if (tabelaEmpresas) {
                this.itemsPerPage = tabelaEmpresas.itemsPerPage;
                this.page = tabelaEmpresas.page;
              }

              sessionStorage.removeItem("tabelaEmpresas");
              this.empresas = data.data;
              this.$store.commit(SET_LOADING, false);
            } else SweetAlert.sweetAlertError(data.errors);
          }
        );
      });
    },

    verificarPermissao(permissao) {
      return PermissoesService.verificarAcesso(Modulo.Empresa, permissao);
    },

    editar(id) {
      this.popularPaginacaoEmpresas();
      this.$router.push({ path: "empresa/cadastro/" + id });
    },

    inativar(id, index) {
      let self = this;

      Swal.fire({
        title: "Tem certeza que deseja excluir esse registro?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("empresa/" + id + "/inativar").then(({ data }) => {
              resolve(data);

              if (data.success === true) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Empresa Inativada com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.empresas.splice(index, 1);
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          });
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Empresas" }]);
    this.$store.dispatch(SET_LOADING, true);
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.listaEmpresas();
    this.permissoesPadrao = Permissoes;
  },
  created() {
    if (
      !PermissoesService.verificarAcesso(Modulo.Empresa, Permissoes.Visualizar)
    ) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
